<template>
  <v-form class="feature-form" ref='form' v-model="valid">

    <v-text-field v-model="postData.object" label="Object of Email" >
    </v-text-field>

    <v-text-field v-model="postData.emailFrom" label="From :" >
    </v-text-field>

    <h3>Versions :</h3>
    <v-layout v-if="isLogged">
      <v-flex xs4>
        <v-select  class="mr-4" label="from" v-model="postData.versionFrom" :items="versions"
          item-text="name"
          item-value="id"
        ></v-select>
      </v-flex>
      <v-flex xs4>
        <v-select  class="mr-4" label="to" v-model="postData.versionTo" :items="versions"
          item-text="name"
          item-value="id"
        ></v-select>
      </v-flex>
    </v-layout>

    <v-combobox  label="To :"
      v-model="postData.emailsTo"
      multiple
      append-icon
      chips
      deletable-chips
    >
    </v-combobox>

    <p class="txt-error">{{ error }}</p>

    <v-divider></v-divider>
    <v-layout class="mt-4" align-end justify-end>
      <v-progress-circular indeterminate color="primary" v-if="pending"></v-progress-circular>
      <p v-if="sending">{{ finishMessage }}</p>
      <v-btn  v-if="!pending && !sending" @click="onValidate" >Send</v-btn>
    </v-layout>
  </v-form>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SendEmailForm',
  props: {
    postData: {
      type: Object,
      default: () => {},
      required: true,
    },
    validate: {
      type: Function,
      default: () => {},
      required: true,
    },
    finish: {
      type: Function,
      default: () => {},
      required: true,
    },
  },
  computed: {
    ...mapState('authenticationModule', ['isLogged']),
    ...mapState('sendEmailModule', ['message']),
    ...mapState('featureModule', ['versions']),
  },
  updated() {
    this.$refs.form.resetValidation();
  },
  data: () => ({
    error: '',
    finishMessage: '',
    pending: false,
    sending: false,
    valid: true,
    rules: {
      empty: v => !!v || 'This field is required',
      // email: v => /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(v) || 'Emails must be valid',
    },
  }),
  methods: {
    onValidate() {
      if (this.valid === true) {
        this.pending = true;
        this.validate(this.postData).then(e => this.onFinish(e));
      }
    },

    onFinish(e) {
      this.pending = false;
      this.sending = true;
      if (e !== undefined && e.error === true) {
        this.error = e.message;
      } else {
        this.finishMessage = this.message;
        this.finish();
      }
    },
  },
};
</script>
